import { render } from "./PagenationUi.vue?vue&type=template&id=fe190c60&scoped=true"
import script from "./PagenationUi.vue?vue&type=script&lang=js"
export * from "./PagenationUi.vue?vue&type=script&lang=js"

import "./PagenationUi.vue?vue&type=style&index=0&id=fe190c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe190c60"]])

export default __exports__